import React from "react";
import Container from "../container";

const ComparePlans = () => {
  return (
    <Container className="max-w-[1200px]">
      {" "}
      <div>
        <div className="mt-32 mb-14">
          <p className="font-extraBold text-white text-center text-30">
            Compare Plans
          </p>
        </div>
        <div>
          <div className="overflow-x-auto">
            <table className="table-auto w-[475px] md:w-full">
              <thead className=" h-16 font-semibold capitalize text-white  border-b-[24px] border-[#06042A]">
                <tr className="">
                  <th className="py-2 whitespace-nowrap pr-3">
                    <div className="font-extraBold text-center text-white text-[12px] uppercase"></div>
                  </th>
                  <th className="py-2 whitespace-nowrap bg-[#100E4F]">
                    <div className="font-extraBold text-center text-white text-[12px] uppercase">
                      Base
                    </div>
                  </th>
                  <th className="py-2 whitespace-nowrap bg-[#100E4F]">
                    <div className="font-extraBold text-center text-white text-[12px] uppercase">
                      Silver
                    </div>
                  </th>
                  <th className="py-2 whitespace-nowrap bg-[#100E4F]">
                    <div className="font-extraBold text-center text-white text-[12px] uppercase">
                      Gold
                    </div>
                  </th>
                  <th className="py-2 whitespace-nowrap bg-[#100E4F]">
                    <div className="font-extraBold  text-white text-[12px] uppercase pr-3">
                      platinum
                    </div>
                  </th>
                  <th className="py-2 whitespace-nowrap bg-[#100E4F]">
                    <div className="font-extraBold text-center text-white text-[12px] m-1 uppercase">
                      DIAMOND
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody className="mt-6">
                <tr className=" bg-[#0D0A3A] h-20 opacity-80">
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase  pl-2">
                        Daily V-Coin in swap limit
                      </p>
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase text-center">1k</p>
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase text-center">5k</p>
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase text-center">10k</p>
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase text-center">50k</p>
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase text-center">no Limit</p>
                    </div>
                  </td>
                </tr>
                <tr className=" bg-[#0D0A3A] h-20 opacity-80">
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase  pl-2">
                        Daily V-Coin in swap limit
                      </p>
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase text-center">10k</p>
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase text-center">25k</p>
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase text-center">no limit</p>
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase text-center">no limit</p>
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase text-center">no Limit</p>
                    </div>
                  </td>
                </tr>
                <tr className=" bg-[#0D0A3A] h-20 opacity-80">
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase  pl-2">
                        Daily V-Coin in swap limit
                      </p>
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase text-center"></p>
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase text-center">-2%</p>
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase text-center">-5%</p>
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase text-center">-10%</p>
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase text-center">-15%</p>
                    </div>
                  </td>
                </tr>
                <tr className=" bg-[#0D0A3A] h-20 opacity-80">
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase  pl-2">Staking multiplier</p>
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase text-center">x1</p>
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase text-center">x1.1</p>
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase text-center">x1.2</p>
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase text-center">x1.3</p>
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase text-center">x1.5</p>
                    </div>
                  </td>
                </tr>
                <tr className=" bg-[#0D0A3A] h-20 opacity-80">
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="font-bold text-[16px] text-white">
                      <p className="uppercase pl-2 ">RETRIVE BONUS</p>
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase"></p>
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase"></p>
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase text-center">+1%</p>
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase text-center">+3%</p>
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase text-center">+5%</p>
                    </div>
                  </td>
                </tr>
                <tr className=" bg-[#0D0A3A] h-20 opacity-80">
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase  pl-2">EXCLUSIVE AVATAR</p>
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase"></p>
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase"></p>
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="flex justify-center">
                      <img
                        className="w-[22px] h-[17px] "
                        src="images/check (2).png"
                        alt="check"
                      />
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="flex justify-center">
                      <img
                        className="w-[22px] h-[17px] "
                        src="images/check (2).png"
                        alt="check"
                      />
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap border-b-2 border-[#1F5885]">
                    <div className="flex justify-center">
                      <img
                        className="w-[22px] h-[17px] "
                        src="images/check (2).png"
                        alt="check"
                      />
                    </div>
                  </td>
                </tr>
                <tr className=" bg-[#0D0A3A] h-20 opacity-80">
                  <td className="p-2 whitespace-nowrap">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase  pl-2">EXCLUSIVE AVATAR</p>
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase"></p>
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap">
                    <div className="font-bold text-[16px]  text-white">
                      <p className="uppercase"></p>
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap">
                    <div className="flex justify-center">
                      <img
                        className="w-[22px] h-[17px] "
                        src="images/check (2).png"
                        alt="check"
                      />
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap">
                    <div className="flex justify-center">
                      <img
                        className="w-[22px] h-[17px] "
                        src="images/check (2).png"
                        alt="check"
                      />
                    </div>
                  </td>
                  <td className="p-2 whitespace-nowrap">
                    <div className="flex justify-center">
                      <img
                        className="w-[22px] h-[17px] "
                        src="images/check (2).png"
                        alt="check"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ComparePlans;
